<div class="cb-margin-left-3x cb-margin-right-3x cb-margin-bottom-3x flex-col flex">
    <div class="start-center flex-row">
        <h3 class="mat-headline-6 flex">
            Standard Plans
        </h3>
    </div>
    <cb-styles></cb-styles>
    <cb-categories></cb-categories>
</div>
